// src/components/superadmin/SuperAdminDashboard.jsx
import React from "react";
import { useAuth } from "../../context/AuthContext";
import SuperLayout from "../layout/SuperAdminLayout";
import DashboardOverview from "../admin/DashboardOverview";

const SuperAdminPanel = () => {
  const { user } = useAuth();

  if (user.role !== "SUPER_ADMIN") {
    return (
      <div className="flex items-center justify-center min-h-screen text-xl text-red-600">
        Access Denied
      </div>
    );
  }

  return <DashboardOverview Layout={SuperLayout} canManage={true} basePath="/superadmin" />;
};

export default SuperAdminPanel;
